import { Record } from 'immutable';
import { MenuCategoryAnalyses } from 'records/MenuCategoryAnalysis';

const defaultValues = {
  menuId: null,
  menuName: null,
  periodProfit: 0,
  annualProfit: 0,
  whatIfCase: null,
  profitPercent: 0,
  salesPercent: 0,
  pricePercent: 0,
  periodicUnitsSold: 0,
  avgPrice: 0,
  avgCost: 0,
  avgCostPercentage: 0,
  avgProfit: 0,
  periodId: 0,
  menuCatList: MenuCategoryAnalyses(),
};

export default class MenuAnalysis extends Record(defaultValues, MenuAnalysis) {
  constructor(values) {
    super({
      ...values,
      menuCatList: values && values.menuCatList
                 ? MenuCategoryAnalyses(values.menuCatList)
                 : defaultValues.menuCatList,
    });
  }

  static findMenuCategoryAnalysisIndexById(menuCatList, categoryId) {
    return menuCatList.findIndex((category) => {
      return category.get('userCategoryId') == categoryId ? category : undefined;
    });
  }

  static findMenuItemsAnalysisIndexById(menuAnalysisItemList, menuitemid) {
    return menuAnalysisItemList.findIndex((menuItem) => {
      return menuItem.get('menuitemid') === menuitemid ? menuItem : undefined;
    });
  }

  updateMenuAnalysisValue(key, value) {
    return this.set(`${ key }`, value);
  }

  updateMenuItemsAnalysisValue(categoryId, menuitemid, key, value) {
    const menuCatList = this.get('menuCatList');
    const categoryIndex = MenuAnalysis.findMenuCategoryAnalysisIndexById(menuCatList, categoryId);
    const menuAnalysisItemList = this.getIn(['menuCatList', categoryIndex, 'menuAnalysisItemList']);
    const menuItemIndex = MenuAnalysis.findMenuItemsAnalysisIndexById(menuAnalysisItemList, menuitemid);
    return this.setIn(['menuCatList', categoryIndex, 'menuAnalysisItemList', menuItemIndex, `${key}`], value);
  }

  updateMenuCategoriesAnalysisValue(categoryId, key, value) {
    const menuCatList = this.get('menuCatList');
    const categoryIndex = MenuAnalysis.findMenuCategoryAnalysisIndexById(menuCatList, categoryId);
    return this.setIn(['menuCatList', categoryIndex, `${key}`], value);
  }

  static toThousands(num, fixed){
    if(num!=undefined){
      if (typeof num !== "number") {
        num = parseFloat(num);
      }
      var reg = /\B(?=(\d{3})+$)/g;
      num = num.toString().split(".");
      fixed = fixed == undefined ? 2 : fixed;

      num[0] = num[0].replace(reg, ",");
      num[1] = num[1] ? num[1].substr(0, fixed) : "00000000000000000".substr(0, fixed);

      return fixed ? num.join(".") : num[0];
    }
    return '0';
  }

  static roundUp(num, decimals) {
    const digits = decimals === undefined ? 2 : decimals;
    const precision = 10 ** digits;
    return Math.ceil(num * precision) / precision;
  }

}
